import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getCity = id => {
  return http.get(
    `${getBaseUrl()}/city/${id}`
  );
};

export const getCities = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/city`
    );
  }
  return http.get(
    `${getBaseUrl()}/city?${paginate}`
  );
};

export const getProvinceCities = id => {
  return http.get(
    `${getBaseUrl()}/cities/${id}`
  );
};

export const updateCity = data => {


  return http.put(
    `${getBaseUrl()}/city/${data.id}`,
    data
  );
};
export const submitCity = data => {

  return http.post(
    `${getBaseUrl()}/city`,
    data
  );
};
